export enum EDateFormat {
  DD_MM_YYYY = "DD/MM/YYYY",
  MM_DD_YYYY = "MM/DD/YYYY",
  YYYY_DD_MM = "YYYY/DD/MM",
  YYYY_MM_DD = "YYYY/MM/DD",
}
